export default __webpack_public_path__ + "static/media/button_icon_02.1c73e695.svg";